import React, { useState,useEffect } from 'react';

function FetchIndicator({samples, table_data}) {
    const [indicatorValue, setindicatorValue] = useState(0);

    const newArray = table_data.map(subArray =>
        subArray.map(element => parseInt(element))
    );

    useEffect(() => {
      
        let number_of_sample = parseInt(samples) // ex αριθμός δείγματος = 15
        let input_data = newArray
        //[[2,4,3,6,5],[8,2,3,4,3],[6,4,1,4,5],[3,8,6,1,2],[6,6,3,4,1]]
        var data = JSON.stringify({"number_of_sample":number_of_sample, "input_data":input_data});
        var url = "/api/indicatorvalue"

        fetch(url, {method: "POST", body: data}).then((res) =>
           res.json().then((res) => {
           console.log("res:",res)
           setindicatorValue(res.data["Indicator value"])
          })
        )
    })

    if(indicatorValue !== 0){
        return (
            <div className='container' style = {{display: "flex", marginTop: "5%",   justifyContent: 'center',
            alignItems: 'center'}}>
                <h5>Υπολογισθείσα τιμή δείκτη Ικανοποίησης:</h5>
                <p style = {{marginLeft: "15%"}}><strong>{indicatorValue}</strong></p>
            </div>
        );
    }
    else{
        return <></>
    }
}

export default FetchIndicator;
